import $ from 'jquery';

export default function initIosDetection() {
  const matches = !!navigator.userAgent.match(/(iPad|iPhone|iPod)/i);

  if(matches) {
    $("body").addClass('is-ios');
  }
}